import { api } from '../App';

export const getPerformance = (date = null) => {
    return api.get(`/people/stat`, { params: { date: date } });
};
